import React, { useState, useRef } from 'react';
import { getEncUrl } from '../../actions/CCAvenueAction'
import swal from 'sweetalert';
import { salesforceSendFormNumber } from '../../actions/StudentAction';


const CCAvenue = ({paymentConfig,userDetail,selectedMethodFeeDetail,feeDetail}) => {
    const formRef = useRef(null);
    const [loading,setLoading] = useState(false)
    const [encRequestRes, setEncRequestRes] = useState()
    const [formActionUrl,setFormActionUrl] = useState();

    const {form_num,name,id,email,address1,city,city_id, other_city,zip_code,mobile_no} = userDetail !==undefined && userDetail
    const {instData} = selectedMethodFeeDetail
    const {installment_type,net_payable_amount,scholarship_amount,scholarship_percentage,total_fee} = feeDetail !==undefined && feeDetail
    let accessCode = `${paymentConfig.access_code}`

    const addressFormat = address1!==null && address1.replace(/[&\/\\#+()!@$~%.`'":*?^<>{}]/g, '')
    const cityFormat = city_id !== null && city_id === 0 ? other_city !== null && other_city !== undefined ? other_city.replace(/[&\/\\#+()!@$~%.`'":*?^<>{}]/g, ''):'' : city

    let order_no =new Date().getUTCMilliseconds();
    let orderWithFormNum=`${id}-${order_no}-${form_num}`

    const checkout = async () => {
        setLoading(true)

        const data = {
            student_id: id,
            amount:parseFloat(instData?.amount).toFixed(2) ,
            gateway_id: paymentConfig.id,
            merchant_id:paymentConfig?.merchant_id,
            order_id:orderWithFormNum,
            language:'EN',
            billing_address:addressFormat,
            billing_city:cityFormat,
            billing_state:'MH',
            billing_zip:'zip_code',
            billing_country:'India',
            billing_tel:mobile_no,
            billing_name:name,
            delivery_name:name,
            delivery_address:addressFormat,
            delivery_city:cityFormat,
            delivery_state:cityFormat,
            delivery_zip:zip_code,
            delivery_country:'India',
            delivery_tel:mobile_no,
            billing_email:email,
            success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/success`,
            failure_url:`${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/failure`,
            scholarship_amount:scholarship_amount,
            net_payable_amount:net_payable_amount,
            installments_id:instData?.installment_id,
            installment_type:instData?.installment_number ==0 ? "lumpsum" :installment_type,
            scholarship_percentage:scholarship_percentage,
            actual_inst_amt:parseFloat(instData?.amount).toFixed(2),
            course_fee:total_fee,
            installments_number:instData?.installment_number
          }
      

        try {
          const EncUrlRes = await getEncUrl(data)
          if (EncUrlRes.encrypted_data !== undefined) {
              setLoading(true)
              salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
              setEncRequestRes(EncUrlRes?.encrypted_data);
              setFormActionUrl(EncUrlRes?.ccavenue_url)
              setTimeout(() => { formRef.current.submit(); }, 1000)
             
          }
          else {
              swal(`Payment Failed! We couldn't process your payment. Please Try Again!`, '', 'error');
              setLoading(false)
          }
          
        } catch (error) {
          console.log('ccavenue error...',error)
        }
        
            
    }
   
    return (
        <React.Fragment>
            <div>
            {loading ? <button type="submit" disabled className="banktransfer_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Processing ...</button> : 
               <button onClick={checkout} className='banktransfer_btn'>Pay with CCAvenue</button>
            }
                
                <form ref={formRef}
                    id="nonseamless"
                    method="POST"
                    name="redirect"
                    action={formActionUrl !==undefined ? formActionUrl : ''}
                    >
                    <input type="hidden" id="encRequest" name="encRequest" value={encRequestRes} />
                    <input type="hidden" name="access_code" id="access_code" value={accessCode} />
                </form>
            </div>

        </React.Fragment>
    )
}

export default CCAvenue